import type { UniclientAction } from '../action';
import type { PriceProps } from './price';
import type { UniclientWizardComponentBase } from './types';

export type PriceCardProps<TComponentAttributes extends string = string> = PriceProps<TComponentAttributes> & {
  readonly action?: UniclientAction;
  readonly secondaryAction?: UniclientAction;
};

export type UniclientPriceCardProps = PriceCardProps & UniclientWizardComponentBase<'price_card'>;

export function priceCard(props: PriceCardProps): UniclientPriceCardProps {
  return { ...props, type: 'price_card' };
}
